var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBankShield = function SvgBankShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 34V18h2v16zm10 0V18h2v16zM7.077 14v-1.693L24 4.231l16.923 8.076V14zm5.296-2h23.254L24 6.5zM7.077 40v-2h22.216q.023.55.096 1.025.072.476.18.975zM33 28.539V18h2v9.539zm7 17.923q-2.95-.735-4.86-3.36-1.908-2.626-1.909-5.848v-4.331l6.77-3.385 6.768 3.385v4.331q0 3.223-1.91 5.848-1.908 2.625-4.859 3.36m-1.45-5.308 6.066-6.054-1.254-1.254-4.812 4.789-1.95-1.95-1.254 1.265z"
  })));
};
export default SvgBankShield;